import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { environment } from 'src/environments/environments';

export interface AdminPresenceChangedEvent {
  type: 'apartment' | 'laundry' | 'restaurant' | 'club';
  tenantId: string;
  isOnline: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  private socket: Socket | null = null;
  private connectedToken: any = null;

  private presenceChangedSubject = new Subject<AdminPresenceChangedEvent>();
  private reconnectedSubject = new Subject<void>();

  presenceChanged$ = this.presenceChangedSubject.asObservable();
  reconnected$ = this.reconnectedSubject.asObservable();

  constructor(private router: Router) { }

  connect(token: any): void {
    if (!token) {
      return;
    }
    if (this.socket && this.connectedToken === token) {
      return;
    }
    this.disconnect();

    this.connectedToken = token;
    this.socket = io(environment.socketUrl, {
      auth: { token },
      transports: ['websocket'],
      reconnection: true
    });

    this.socket.on('admin:presence:changed', (data: AdminPresenceChangedEvent) => {
      this.presenceChangedSubject.next(data);
    });

    this.socket.io.on('reconnect', () => {
      this.reconnectedSubject.next();
    });

    this.socket.on('connect_error', (err: any) => {
      if (err && (err.message === 'No token' || err.message === 'Invalid token')) {
        this.disconnect();
        this.router.navigate(['/login']);
      }
    });
  }

  disconnect(): void {
    this.socket?.disconnect();
    this.socket = null;
    this.connectedToken = null;
  }
}
